import $ from 'jquery';

class FAQ {
    constructor(){
        const _this = this;
        const jssection = document.querySelectorAll('.js-faq');
        jssection.forEach(function(js){
            const accors = js.querySelectorAll('.item-faq');

            accors.forEach((item, idx) => {
                let head = item.querySelector('.item-faq-head');
                if (head){
                    head.addEventListener('click', (e) => {
                        accors.forEach((temp, idxTmp) => {
                            let headTemp =  temp.querySelector('.item-faq-head');
                            let contentTemp = temp.querySelector('.item-faq-content');
                            if (idxTmp == idx){
                                if (temp.classList.contains('active')){
                                    temp.classList.remove('active');
                                    _this.jquerySlideUp(contentTemp);
                                }else{
                                    temp.classList.add('active');
                                    _this.jquerySlideDown(contentTemp);
                                }
                            }else{
                                if (temp.classList.contains('active')){
                                    temp.classList.remove('active');
                                    _this.jquerySlideUp(contentTemp);
                                }
                            }
                        })    
                    })
                }
    
            });
        })

        // const titles = document.querySelectorAll('#faq .faq-title');
        // const contents = document.querySelectorAll('#faq .item-faq-content');
        // const updateWidths = () => {
        //     let widths = Array.from(titles).map((title) => title.clientWidth);
        //     let maxWidth = Math.max(...widths);
        //     contents.forEach((content) => {
        //         content.style.width = maxWidth + 'px';
        //     });
        // };
        // updateWidths();
        // window.addEventListener('resize', updateWidths);
    }

    jquerySlideDown(element, duration = 250) {
        $(element).stop(true, true).slideDown(duration);
    }

    jquerySlideUp(element, duration = 250) {
        $(element).stop(true, true).slideUp(duration);
    }
}
export default FAQ;